import { render, staticRenderFns } from "./CustomTabContent.vue?vue&type=template&id=13bb1cbc&"
import script from "./CustomTabContent.vue?vue&type=script&lang=js&"
export * from "./CustomTabContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomTabContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports